var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 15.2843C11.6667 16.0335 10.9034 16.6668 10 16.6668C9.0967 16.6668 8.33337 16.0335 8.33337 15.2843V15.0002H11.6667V15.2843ZM17.1009 12.6727L15.6 11.1702V7.44684C15.6 4.54601 13.515 2.08267 10.7492 1.71601C9.14837 1.50351 7.5317 1.99184 6.3192 3.05517C5.0992 4.12351 4.40004 5.66101 4.40004 7.27267L4.3992 11.1702L2.8992 12.6735C2.50837 13.0643 2.39254 13.6477 2.6042 14.1585C2.8167 14.6693 3.31087 15.0002 3.8642 15.0002H6.6667V15.2843C6.6667 16.966 8.1617 18.3335 10 18.3335C11.8384 18.3335 13.3334 16.966 13.3334 15.2843V15.0002H16.135C16.6884 15.0002 17.1825 14.6702 17.3942 14.1585C17.6067 13.6477 17.4909 13.0643 17.1009 12.6727Z",
    fill: "#E6F7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.1d68b9b4dab7501eaf450798bc134bf3.svg";
export { ForwardRef as ReactComponent };